import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UiStateManagementBaseService {
  protected expandViewSubject = new BehaviorSubject<boolean>(false);
  protected toggleAirportDropDownSubject = new BehaviorSubject<boolean>(false);

  expandView$ = this.expandViewSubject.asObservable();
  toggleAirportDropDown$ = this.toggleAirportDropDownSubject.asObservable();
}
